var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import createGenerateRolls from './generateRolls';
import defaultRandom from './random';
export var getDefaultRollConfigOptions = function (helpers) {
    if (helpers === void 0) { helpers = {}; }
    var _a = helpers.random, random = _a === void 0 ? defaultRandom : _a, _b = helpers.context, context = _b === void 0 ? {} : _b, _c = helpers.maxRandomRolls, maxRandomRolls = _c === void 0 ? 100000 : _c;
    return {
        random: random,
        context: context,
        maxRandomRolls: maxRandomRolls,
    };
};
var wrapRandomToPreventCrashes = function (config) {
    var maxRandomRolls = config.maxRandomRolls, random = config.random;
    // Don't wrap if limitation is disabled
    if (maxRandomRolls === 'unlimited_rolls_not_recommended')
        return random;
    var rollCount = 0;
    return function (min, max) {
        rollCount++;
        if (rollCount > maxRandomRolls)
            throw new Error("Cannot roll more than " + maxRandomRolls + " dice");
        return random(min, max);
    };
};
export var getFinalRollConfig = function (config, overrides) {
    if (overrides === void 0) { overrides = {}; }
    var finalConfig = __assign(__assign({}, config), overrides);
    var random = wrapRandomToPreventCrashes(finalConfig);
    return __assign(__assign({}, finalConfig), { random: random, generateRolls: createGenerateRolls(random) });
};
